/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { getRejectedFilters, getRejectedPagination } from '../../selectors';
import { setRejectedPagination } from '../../actions';
import { getRejectedReports } from '../../services';

const useRejectedSummary = () => {
  const filters = useSelector(getRejectedFilters);
  const { pageNumber, pageSize } = useSelector(getRejectedPagination);
  const dispatchSetRejectedPagination = useAction(setRejectedPagination);
  const [rejectedReports, setRejectedReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleFilterChange = async () => {
    setIsLoading(true);
    const { rejects, totalRecords } = await getRejectedReports({
      ...filters,
      page: pageNumber,
      pageSize,
    });

    setRejectedReports(rejects);
    dispatchSetRejectedPagination({ totalRecords });
    setIsLoading(false);
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters, pageNumber, pageSize]);

  return {
    rejectedReports,
    isLoading,
    handleFilterChange,
  };
};

export default useRejectedSummary;
